<h2 class="h2">{{ 'reports.links.REPORT_LIST' | translate }}</h2>
<ul>
    <li *ngFor="let reportLink of REPORT_LINKS">
        <a [routerLink]="['./', reportLink.link]">{{ reportLink.i18n | translate }}</a>
    </li>
</ul>